import styled, { css } from "styled-components";
import { breakpoints } from "styles/grid";

// #####################################################

export const SelectorSectionStyled = styled(
	({
		bold,
		cursorText,
		min,
		customWidth = 198,
		withOverflowEllipsis,
		isOpen,
		...props
	}) => <div {...props} />
)`
	display: flex;
	justify-content: space-between;
	flex: 1;
	position: relative;
	text-align: left;
	min-height: var(--dz-sys-input-height);
	width: 100%;
	padding: 0.5rem 1rem;
	align-items: center;
	color: var(--dz-sys-text-color);
	transition: box-shadow 100ms;
	border: 1px solid var(--dz-sys-input-border-color);
	border-radius: var(--dz-sys-input-border-radius);

	/* MARCIN_P: Dodałem sztywną wartość (200px - border 2 x 1px) bo inaczej przy wpisywaniu 1 litery i zmiany font-weight na bold (57 linijka) kontener sam się rozszerzał o kilkanaście px. */
	${({ customWidth }) =>
		customWidth &&
		css`
			width: ${customWidth}px;
		`}

	${({ $customPadding }) =>
		$customPadding &&
		css`
			padding: ${$customPadding};
		`}

	${({ withOverflowEllipsis }) =>
		withOverflowEllipsis &&
		css`
			overflow: hidden;
			text-overflow: ellipsis;
		`}

	${({ bold }) =>
		bold === true &&
		css`
			font-weight: bold;
		`}

	${({ cursorText }) =>
		cursorText === true
			? css`
					cursor: text;
			  `
			: css`
					cursor: pointer;
			  `}

	${({ disabled }) =>
		disabled &&
		css`
			opacity: 0.75;
		`}

		${({ isOpen, layerSide }) =>
		isOpen
			? css`
					box-shadow: var(--dz-sys-input-shadow);
					border: 1px solid var(--dz-sys-input-border-color-hover);

					@media (min-width: ${breakpoints.tablet}px) {
						${layerSide === "top"
							? css`
									border-top-left-radius: 0px;
									border-top-right-radius: 0px;
									border-top: none;
							  `
							: css`
									border-bottom-left-radius: 0px;
									border-bottom-right-radius: 0px;
									border-bottom: none;
							  `}
					}
			  `
			: css`
					&:focus,
					&:focus-within,
					&:hover {
						box-shadow: var(--dz-sys-input-shadow);
						border: 1px solid var(--dz-sys-input-border-color-hover);
					}
			  `}
`;

// #####################################################
